(() => {
  const WRAP = ".collection-load-more";
  const BTN = ".collection-load-more__btn";
  const STATUS = ".collection-load-more__status";

  async function fetchHTML(url) {
    const res = await fetch(url, { credentials: "same-origin" });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return await res.text();
  }

  function killReveal(rootEl) {
    // Prestige cache souvent les cards via reveal/opacity/transform
    const nodes = [
      rootEl,
      ...rootEl.querySelectorAll("[reveal], .reveal, .is-hidden, .will-reveal, .js-reveal")
    ];

    nodes.forEach((n) => {
      try {
        n.removeAttribute("reveal");
        n.classList.remove("reveal", "is-hidden", "will-reveal", "js-reveal");
        // force visible
        n.style.opacity = "1";
        n.style.transform = "none";
        n.style.visibility = "visible";
      } catch (e) {}
    });
  }

  function init() {
    const wrap = document.querySelector(WRAP);
    if (!wrap) return;

    const btn = wrap.querySelector(BTN);
    const status = wrap.querySelector(STATUS);
    if (!btn) return;

    // évite double-binding
    if (btn.dataset.bound === "1") return;
    btn.dataset.bound = "1";

    btn.addEventListener("click", async (e) => {
      e.preventDefault();

      const nextUrl = wrap.dataset.nextUrl;
      if (!nextUrl) return;

      // IMPORTANT: cible le product-list de LA section (sinon tu peux append dans un autre product-list)
      const sectionId = wrap.dataset.sectionId;
      const list =
        (sectionId && document.querySelector(`#shopify-section-${sectionId} product-list`)) ||
        document.querySelector("product-list");

      if (!list) {
        console.error("[Load more] product-list introuvable sur la page");
        return;
      }

      btn.disabled = true;
      if (status) {
        status.textContent = "Chargement…";
        status.style.display = "block";
      }

      try {
        const html = await fetchHTML(nextUrl);
        const doc = new DOMParser().parseFromString(html, "text/html");

        const newList =
          (sectionId && doc.querySelector(`#shopify-section-${sectionId} product-list`)) ||
          doc.querySelector("product-list");

        const newWrap = doc.querySelector(WRAP);

        if (!newList) throw new Error("product-list introuvable dans la réponse");

        // récupère uniquement les nouveaux nodes (produits + inserts)
        const children = Array.from(newList.children);

        // append
        const frag = document.createDocumentFragment();
        children.forEach((el) => {
          // on neutralise reveal AVANT d’insérer (sinon invisibles)
          killReveal(el);
          frag.appendChild(el);
        });

        list.appendChild(frag);

        // met à jour la prochaine URL
        const newNext = newWrap?.dataset?.nextUrl;
        if (newNext) {
          wrap.dataset.nextUrl = newNext;
          if (status) status.style.display = "none";
        } else {
          wrap.remove();
        }
      } catch (err) {
        console.error("[Load more]", err);
        if (status) status.textContent = "Erreur, réessaie.";
      } finally {
        btn.disabled = false;
      }
    });
  }

  document.addEventListener("DOMContentLoaded", init);
  init();
})();
